import React, { useContext } from 'react';
import { styled } from '@mui/material/styles';
import { IconButton, Tooltip } from '@mui/material';
import {
    SkipNext,
    SkipPrevious,
    Eject, // Rotated and used for forward/back one second
    PauseCircleOutline,
    PlayCircleOutline
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { VideoTrimmerContext } from './VideoTrimmerProvider';

const PREFIX = 'SeekControls';

const classes = {
    root: `${PREFIX}-root`,
    backOneSecondBtn: `${PREFIX}-backOneSecondBtn`,
    forwardOneSecondBtn: `${PREFIX}-forwardOneSecondBtn`,
    playPauseBtn: `${PREFIX}-playPauseBtn`
};

const Root = styled('div')({
    [`&.${classes.root}`]: {
        padding: 8,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& .MuiIconButton-root': {
            '& .MuiSvgIcon-root': {
                fill: '#102A43'
            }
        }
    },

    [`& .${classes.backOneSecondBtn}`]: {
        '& .MuiSvgIcon-root': {
            transform: 'rotate(-90deg)'
        }
    },

    [`& .${classes.forwardOneSecondBtn}`]: {
        '& .MuiSvgIcon-root': {
            transform: 'rotate(90deg)'
        }
    },

    [`& .${classes.playPauseBtn}`]: {
        '& .MuiSvgIcon-root': {
            fontSize: 32
        }
    }
});

const SeekControls = (props) => {
    const { t } = useTranslation();

    const {
        videoIsPlaying, setVideoIsPlaying,
        skipToClipStart,
        skipToClipEnd,
        skipForward,
        skipBackward
    } = useContext(VideoTrimmerContext);

    return (
        <Root className={classes.root}>
            <IconButton onClick={skipToClipStart} size="large">
                <SkipPrevious />
            </IconButton>
            <Tooltip title={t('videoPlayer.tooltips.backOneSecond')}>
                <IconButton
                    className={classes.backOneSecondBtn}
                    onClick={() => skipBackward(1)}
                    size="large">
                    <Eject />
                </IconButton>
            </Tooltip>
            { videoIsPlaying ?
                <IconButton
                    className={classes.playPauseBtn}
                    onClick={() => setVideoIsPlaying(false)}
                    size="large">
                    <PauseCircleOutline />
                </IconButton> :
                <IconButton
                    className={classes.playPauseBtn}
                    onClick={() => setVideoIsPlaying(true)}
                    size="large">
                    <PlayCircleOutline />
                </IconButton>
            }
            <Tooltip title={t('videoPlayer.tooltips.forwardOneSecond')}>
                <IconButton
                    className={classes.forwardOneSecondBtn}
                    onClick={() => skipForward(1)}
                    size="large">
                    <Eject />
                </IconButton>
            </Tooltip>
            <IconButton onClick={skipToClipEnd} size="large">
                <SkipNext />
            </IconButton>
        </Root>
    );
};

export default SeekControls;
